<template>
  <div id="soil-real" style="overflow:hidden;">
    <div class="soilReal-data">
      <div class="soilReal-data-head">
        <div class="soilReal-head-left">
          <div class="soilReal-left-title">
            <span class="soilReal-left-title-container" style="">墒情实时数据</span>
          </div>
          <div class="soilReal-left-state">
            <span class="soilReal-left-state-container"> 设备状态：{{soilDeviceState}}</span>
          </div>
        </div>

        <div class="soilReal-head-right">
          <div class="soilReal-head-right-container">
            设备名
            <el-select @change="soilRealChange($event)" v-model="soilDevice" filterable>
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in soilOptionList">
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="soilReal-data-content" style="overflow:auto;" >
        <div v-for="(row,index) in sliceList(soilDataList, 5)" :key="index" style=" width: 100%;height: 20%;">
          <div class="soilReal-content-body">
            <div class="soilReal-content-bodyContainer"  v-for="(item,i) in row">
              <div class="soilReal-content-container">
                <div class="soilReal-content-containerTr">
                  <span class="soilReal-content-containerTd">{{item.ts}}</span>
                </div>
                <div class="soilReal-content-containerTr">
                  <span class="soilReal-content-containerTd">{{item.name}}</span>
                </div>
                <div class="soilReal-content-containerTr">
                  <span class="soilReal-content-containerTd">{{item.value}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import {getDeviceValue} from "../../until/api/MeteSoil";
  export default {
    name: 'SoilRealData',
    components: {},
    data() {
      return {
        soilOption: [],
        soilOptionList: [],
        soilDeviceJson: {},
        soilDevice: '',
        soilDataList: [],
        soilDeviceState: '-',
        soilTime: null,
        soilOptionMap: null,
      }
    },

    computed: {
      sliceList() {
        return function (data, count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i/count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      }
    },

    beforeDestroy() {
      clearInterval(this.soilTime);
      this.soilTime = null;
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      // let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      //设置设备列表
      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {//获取设备
        that.soilDeviceBoard(deviceList);
      })
    },

    methods: {
      /**
       * 设置设备列表
       * @param response
       */
      soilDeviceBoard(response) {
        // if(response.data.length === 0) return;
        // for(let i = 0; i < response.data.length; i++) {
        //   let meteJson = {};
        //   meteJson.id = response.data[i].id.id;
        //   meteJson.name = response.data[i].name;
        //   meteJson.type = response.data[i].id.entityType;
        //   this.soilOption.push(meteJson);
        // }
        // if(this.soilOption.length > 0) {
        //   // this.soilDevice = this.soilOption[0].id;
        //   // //获取设备最后一次连接时间
        //   // this.soilConnectTime();
        //   // //根据选中的设备获取设备数据
        //   // this.soilDashInfo();
        //   this.soilDeviceInfo(0, this.soilOption.length)
        // }

        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let soilJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          };

          let promise = this.$MeteSoilCommon.getLastConnectTime(soilJson.type, soilJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            soilJson.state = time < beforeTime ? 'red' : 'green';
            return soilJson;
          });

          promises.push(promise);
        }

        Promise.all(promises).then(results => {
          this.soilOption = results;
          this.soilOptionMap = null;
          this.soilOptionMap = new Map(this.soilOption.map(item => [item.id, item]));

          if(this.soilOption.length > 0) {
            this.soilDeviceInfo(0, this.soilOption.length)
          }
        })
      },

      /**
       * 筛选出墒情设备
       * @param j
       * @param length
       */
      soilDeviceInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.soilOption[j].id, function (deviceInfo) {
          that.soilOption[j].deviceInfo = deviceInfo;
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.soilDeviceOption(j, keyData);
            if(++j < length) {
              that.soilDeviceInfo(j, length);
            } else {
              that.soilDevice = that.soilOptionList[0].id;
              that.soilDeviceJson = that.soilOptionList[0].deviceInfo;
              //获取设备最后一次连接时间
              that.soilConnectTime();
              //根据选中的设备获取设备数据
              that.soilDashInfo();
            }
          })
        })
      },

      /**
       * 对每个墒情设备的key进行筛选
       * @param j
       * @param keyData
       */
      soilDeviceOption(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('soil') >= 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.soilOptionList.push(this.soilOption[j]);
        }
      },

      /**
       * 切换设备
       * @param event
       */
     soilRealChange(event) {
        this.soilDevice = event;
        clearInterval(this.soilTime);
        this.soilTime = null;
        for(let i = 0; i < this.soilOptionList.length; i++) {
          if(this.soilOptionList[i].id == this.soilDevice) {
            this.soilDeviceJson = this.soilOptionList[i].deviceInfo;
            //获取最后一次连接时间
            this.soilConnectTime();
            //根据选中的设备获取设备数据
            this.soilDashInfo();
            break;
          }
        }
      },

      /**
       * 根据据选中的设备获取设备数据
       */
      soilDashInfo() {
        let that = this;
        this.$MeteSoilCommon.getDeviceKeyList(this.soilDeviceJson, function (keyData) {//获取设备id
          that.soilDeviceKeys(keyData);//获取设备key
        });

        this.soilTime = window.setInterval(() => {
          setTimeout(() => {
            this.$MeteSoilCommon.getDeviceKeyList(this.soilDeviceJson, function (keyData) {//每隔一分钟获取一次设备id
              that.soilDeviceKeys(keyData);//获取设备key
            })
          },0)
        }, 1000 * 60)
      },

      /**
       * 获取设备key
       * @param deviceId
       */
      soilDeviceKeys(keyData) {
        let keyList = keyData.split(",");
        let strKey = '';
        //筛选出墒情属性
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('soil') >= 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }
        //获取设备value
        if(strKey != '') {
          this.soilDeviceValues(strKey);
        } else {
          this.soilDataList = [];
        }
      },

      /**
       * 获取设备value
       * @param deviceId
       * @param deviceKey
       */
      soilDeviceValues(strKey) {
        let soilResponse = [];
        getDeviceValue(this.soilDeviceJson.entityType, this.soilDeviceJson.id, strKey).then(response => {
          for(let obj in response.data) {
            for(let i = 0; i < response.data[obj].length; i++) {
              let soilValue = {};
              soilValue.name = obj;
              soilValue.ts = response.data[obj][i].ts;
              soilValue.value = parseFloat(response.data[obj][i].value);
              soilResponse.push(soilValue);
            }
          }
          soilResponse.sort(function (a, b) {
            return b.ts < a.ts ? -1 : 1;
          });

          this.soilDataList = [];
          for(let i = 0; i < soilResponse.length; i++) {
            let soilValue = {};
            soilValue.ts = this.$commonFun.dateFormat(soilResponse[i].ts);
            soilValue.name = this.$t(soilResponse[i].name).split(',')[0];
            soilValue.value = this.$t(soilResponse[i].name).split(",")[1] === undefined ?
              soilResponse[i].value : soilResponse[i].value + this.$t(soilResponse[i].name).split(",")[1];
            this.soilDataList.push(soilValue);
          }
        }).catch(error => {
          console.log("error",error);
        })
      },

      /**
       * 判断是否离线
       */
      soilConnectTime() {
        let option = this.soilOptionMap.get(this.soilDevice);
        if(option) {
          this.soilDeviceState = option.state === 'red' ? '离线' : '在线';
        } else {
          this.soilDeviceState = '离线';
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../less/SoilRealData";
</style>

<style>
  .soilReal-data-content::-webkit-scrollbar {
    display: none;
  }

  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/SoilRealData.vue